import { ScannerCard } from '@Types/Scanner.types';
import { SCANNER_CARDS } from '@Utils/constants';
import { AxiosResponse } from 'axios';

export const getWeeklyFails = (result: AxiosResponse, failedStatus: string, failedOffice: string) => {
  const successStatusItems = result.data.find(
    (item: { status: string; officeName: string }) => item.status === failedStatus && item.officeName === failedOffice,
  );

  if (successStatusItems === undefined) {
    return { status: failedStatus, officeName: failedOffice, amount: 0 };
  }

  return {
    status: successStatusItems.id,
    officeName: successStatusItems.officeName,
    amount: successStatusItems.amount,
  };
};

export const getAssetStatusIcon = (type: string) => {
  switch (type) {
    case 'New':
      return 'fa-solid fa-sparkles';
    case 'Under Repair':
      return 'fa-light fa-screwdriver-wrench';
    case 'Damaged':
      return 'fa-regular fa-warning';
    case 'Warranty Close to Expire':
      return 'fa-solid fa-award';
    default:
      return '';
  }
};

export const getModifierAsset = (type: string) => {
  switch (type) {
    case 'New':
      return 'new';
    case 'Under Repair':
      return 'repair';
    case 'Damaged':
    case 'Warranty Close to Expire':
      return 'damaged';
    default:
      return '';
  }
};

export const getCheckCards = (data: AxiosResponse, defaultPercentage: string, defaultAmount: string) => {
  SCANNER_CARDS.forEach((card: ScannerCard) => {
    const logTypesData = data.data.weeklyComparisons.find(
      (responseObject: { logType: string }) => responseObject.logType === card.logTypeId,
    );
    if (logTypesData) {
      const cardIndex = SCANNER_CARDS.findIndex((cardFind) => cardFind.logTypeId === logTypesData.logType);
      SCANNER_CARDS[cardIndex].percentage = logTypesData.percentage;
      SCANNER_CARDS[cardIndex].amount = logTypesData.amount;
      SCANNER_CARDS[cardIndex].description = ' compared to last week';
    } else {
      const cardIndex = SCANNER_CARDS.findIndex((indexCard) => card.logTypeId === indexCard.logTypeId);
      SCANNER_CARDS[cardIndex].percentage = defaultPercentage;
      SCANNER_CARDS[cardIndex].amount = defaultAmount;
      SCANNER_CARDS[cardIndex].description = "Can't compare with last week";
    }
  });

  return SCANNER_CARDS;
};
